<template>
  <ODialog ref="dialog" :maxWidth="400">
    <v-card>
      <v-card-text class="pa-6">
        <!-- <div class="subtitle-2">Cor</div> -->
        <div>
          <v-btn-toggle v-model="selectedColorIndex">
            <v-btn small v-for="c in colors" :key="c" :color="c">
              <v-icon
                v-if="currentColor == c"
                color="white"
                v-html="'mdi-check'"
              />
            </v-btn>
          </v-btn-toggle>
        </div>
      </v-card-text>
      <ODialogButtons class="pa-6" @cancel="dismiss" @apply="apply" />
    </v-card>
  </ODialog>
</template>

<script>
export default {
  data() {
    return {
      selectedColorIndex: null,
      colors: [
        'default',
        'red',
        'orange',
        'green',
        'blue',
        'deep-purple',
        'grey'
      ]
    }
  },
  computed: {
    currentColor() {
      if (this.selectedColorIndex == null) return null
      return this.colors[this.selectedColorIndex]
    }
  },
  methods: {
    open() {
      this.selectedColorIndex = null
      return this.$refs.dialog.$open()
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    apply() {
      this.$refs.dialog.$apply(this.colors[this.selectedColorIndex])
    }
  }
}
</script>

<style></style>
